import { render, staticRenderFns } from "./CompanyReferentsTable.vue?vue&type=template&id=7a33ebb2&scoped=true&"
import script from "./CompanyReferentsTable.vue?vue&type=script&lang=ts&"
export * from "./CompanyReferentsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a33ebb2",
  null
  
)

export default component.exports